module.exports = __webpack_public_path__ + "static/media/AmazonGraphics7.204db967.jpg";